<template>
    <vx-expandable-card data-test="sharing-card">
        <template v-slot:content>
            <div class="text-xl font-extrabold mb-4">Sharing</div>
            <vx-alert v-if="null === props.sharing" color="slate" :closeable="false" data-test="not-shared">
                Not shared to Bandwidth
            </vx-alert>
            <template v-else>
                <dl class="flex flex-col gap-3 text-sm">
                    <div>
                        <dt class="font-bold">Upstream</dt>
                        <dd class="text-slate-500">
                            <span v-if="props.sharing.upstream_cnp_id" class="font-mono">{{
                                props.sharing.upstream_cnp_id
                            }}</span>
                            <span v-else>—</span>
                        </dd>
                    </div>
                    <div>
                        <dt class="font-bold">Status</dt>
                        <dd>
                            <vx-badge
                                :color="
                                    props.sharing.sharing_status
                                        ? sharingStatusColors[props.sharing.sharing_status]
                                        : 'slate'
                                "
                                size="xs"
                                data-test="sharing-status"
                            >
                                {{
                                    props.sharing.sharing_status
                                        ? sharingStatusLabels[props.sharing.sharing_status]
                                        : '—'
                                }}
                            </vx-badge>
                        </dd>
                    </div>
                    <div>
                        <dt class="font-bold">Shared</dt>
                        <dd class="text-slate-500">
                            {{ props.sharing.shared_date ? shortDateTime(props.sharing.shared_date) : '—' }}
                        </dd>
                    </div>
                    <div>
                        <dt class="font-bold">Status date</dt>
                        <dd class="text-slate-500">
                            {{ props.sharing.status_date ? shortDateTime(props.sharing.status_date) : '—' }}
                        </dd>
                    </div>
                </dl>
                <vx-alert
                    v-if="'DECLINED' === props.sharing.sharing_status"
                    color="danger"
                    :closeable="false"
                    class="mt-4"
                    data-test="declined"
                >
                    <div class="flex flex-col gap-2">
                        <div class="flex flex-wrap gap-1">
                            <vx-badge
                                v-for="category in props.sharing.rejection_category"
                                :key="category"
                                color="danger"
                                size="xs"
                                data-test="rejection-category"
                            >
                                {{ rejectionCategoryLabels[category] ?? category }}
                            </vx-badge>
                        </div>
                        <div v-if="props.sharing.explanation" data-test="explanation">
                            {{ props.sharing.explanation }}
                        </div>
                        <div class="font-bold">Edit the fields TCR allows, then Re-share</div>
                    </div>
                </vx-alert>
            </template>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxAlert, VxBadge, VxExpandableCard } from '@voxie/frontend-components';
import {
    rejectionCategoryLabels,
    sharingStatusColors,
    sharingStatusLabels,
} from '~/components/kiosk/kiosk-ten-dlc/registration/tenDlcRegistrationLabels';
import type { TcrSharing } from '~/services/adminTenDlcRegistrationClient.types';
import { shortDateTime } from '~/utils/date';

const props = defineProps<{ sharing: TcrSharing | null }>();
</script>
